import React from 'react';

import './index.module.less';
import BrowserHistory from '@helpers/BrowserHistory';
import { paths } from '@helpers/Constants/paths';
import PageNavigator from '@helpers/PageNavigator';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';
import deviceImg from './images/img_device.png';
import FridayService from '@services/friday';

const tipsData = [
  {
    title: '实时定位',
    icon: require('./images/icon_location.png'),
  },
  {
    title: '双向通话',
    icon: require('./images/icon_call.png'),
  },
  {
    title: '安全守护',
    icon: require('./images/icon_guard.png'),
  },
  {
    title: '紧急求助',
    icon: require('./images/icon_sos.png'),
  },
];

const Empty = () => {
  const toScanCode = () => {
    FridayService.addEvent('bind_device_scan_self_show', {source: '定位页'});
    BrowserHistory.push(`${PUBLIC_URL}${paths.scan}`);
  };
  const toDetailPage = async () => {
    const url = 'https://r302.cc/wq23lnj';
    PageNavigator.to({ url });
  };
  return (
    <div styleName="empty-container">
      <NavBar
        title="学生证"
        hideBackButton={true}
        RightBtnComponent={
          <div
            className="flex flex-center"
            styleName="nav-btn"
            onClick={toScanCode}
          >
            <i className="iconfont icon-saoyisao" styleName="nav-icon" />
          </div>
        }
      />
      <div className="flex" styleName="empty-bg">
        <img src={deviceImg} alt="" styleName="empty-img" />
        <div className="flex" styleName="tips-container">
          {tipsData.map(item => (
            <div styleName="tips-item" className="flex">
              <img styleName="tips-item-img" src={item.icon} alt="" />
              <div styleName="tips-item-title">{item.title}</div>
            </div>
          ))}
        </div>
        <div style={{ width: '100%', margin: '1.2rem 0 .24rem' }}>
          <CommonBtn
            type="auto"
            btnText="立即绑定"
            onConfirm={() => toScanCode()}
          />
        </div>
        <div styleName="tips-text" onClick={toDetailPage}>
          《希沃电子学生证功能介绍》
        </div>
      </div>
    </div>
  );
};

export default Empty;
